import React from 'react'
import { Route, Switch } from 'react-router-dom'

import App from './App'
import Login from './Login'
import Register from './Register'
import Message from './Message'
import PasswordRecovery from './PasswordRecovery';
import PasswordChange from './PasswordChange';



const MainSwitch = () => (
    <Switch>
        <Route path="/login" component={Login} />
        <Route path="/password-recovery" component={PasswordRecovery} />
        <Route path="/password-change" component={PasswordChange} />
        <Route path="/register" component={Register} />
        <Route path="/message" component={Message} />
        <Route path="/" component={App} />
    </Switch>
)
export default MainSwitch


// WEBPACK FOOTER //
// ./src/containers/MainSwitch.js